import * as React from 'react';

// COMPONENTS
import ReadActivity from './ReadActivity';
import UpdateActivity from './UpdateActivity';
import DeleteActivity from './DeleteActivity';

// TYPES
import { ComplaintActionsAction } from '../../../api/models';
import { closeModalType } from '../../../components/GlobalModal';

export enum ViewTypes {
	Create = 'showCreate',
	Read = 'showRead',
	Update = 'showUpdate',
	Delete = 'showDelete'
}

const defaultViewTypes = {
	[ViewTypes.Create]: false,
	[ViewTypes.Read]: false,
	[ViewTypes.Update]: false,
	[ViewTypes.Delete]: false
};

type ShowViewType = (type: string) => void;

interface ComplaintsProgressModalTypes {
	complaintId?: string;
	viewType: ViewTypes;
	activity?: ComplaintActionsAction;
	closeModal?: closeModalType;
	refreshComplaintsProgress: () => {};
	getComplaintsDetailsData: () => {};
}

export interface ComplaintsProgressViewTypes {
	complaintId?: string;
	activity?: ComplaintActionsAction;
	showView: ShowViewType;
	closeModal?: closeModalType;
	refreshComplaintsProgress: () => {};
	getComplaintsDetailsData: () => {};
}

const ComplaintsProgressModal: React.FC<ComplaintsProgressModalTypes> = ({
	complaintId,
	viewType,
	activity,
	closeModal,
	refreshComplaintsProgress,
	getComplaintsDetailsData
}) => {
	const [state, setState] = React.useState({ ...defaultViewTypes, [viewType || ViewTypes.Read]: true });

	const showView: ShowViewType = (viewType) => {
		setState({ ...defaultViewTypes, [viewType]: true });
	};

	if (state.showCreate) {
		return (
			<UpdateActivity
				complaintId={complaintId}
				showView={showView}
				closeModal={closeModal}
				refreshComplaintsProgress={refreshComplaintsProgress}
				getComplaintsDetailsData={getComplaintsDetailsData}
			/>
		);
	} else if (state.showRead) {
		if (activity) {
			return (
				<ReadActivity
					complaintId={complaintId}
					activity={activity}
					showView={showView}
					closeModal={closeModal}
					refreshComplaintsProgress={refreshComplaintsProgress}
					getComplaintsDetailsData={getComplaintsDetailsData}
				/>
			);
		} else return null;
	} else if (state.showUpdate) {
		return (
			<UpdateActivity
				complaintId={complaintId}
				activity={activity}
				showView={showView}
				closeModal={closeModal}
				refreshComplaintsProgress={refreshComplaintsProgress}
				getComplaintsDetailsData={getComplaintsDetailsData}
			/>
		);
	} else if (state.showDelete) {
		if (activity) {
			return (
				<DeleteActivity
					complaintId={complaintId}
					activity={activity}
					showView={showView}
					closeModal={closeModal}
					refreshComplaintsProgress={refreshComplaintsProgress}
					getComplaintsDetailsData={getComplaintsDetailsData}
				/>
			);
		} else return null;
	} else {
		return null;
	}
};

export default ComplaintsProgressModal;
